import { clearDataDogUser } from '../login/helpers';
import { clearLocalStorage, clearSessionStorage } from 'utils/localStorage';

const isRepUser = async authClient => {
  try {
    const accessToken = await authClient.tokenManager.get('accessToken');
    return !!accessToken?.claims?.representativeOf;
  } catch (e) {
    console.log('Cant find accessToken', e);
    return false;
  }
};

export const handleLogout = async authClient => {
  const isFromZendesk = Boolean(window.sessionStorage.getItem('zendeskRedirectUrl'));
  const isUserRep = await isRepUser(authClient);
  const shouldCloseSession = !isUserRep;

  if (shouldCloseSession) {
    try {
      await authClient.revokeAccessToken();
    } catch (e) {
      console.error('Logout failed due to access token revocation error', e);
    }

    try {
      await authClient.closeSession();
    } catch (e) {
      console.error('Logout failed due to session termination error', e);
    }
  }

  clearDataDogUser();
  if (shouldCloseSession) {
    clearLocalStorage();
  }
  if (!isFromZendesk) {
    clearSessionStorage();
  }
};
